<a
  mat-list-item
  routerLink="/"
  routerLinkActive="active"
  [routerLinkActiveOptions]="{ exact: true }"
  >Home</a
>
<a mat-list-item routerLink="/about" routerLinkActive="active">About</a>
<a mat-list-item routerLink="/contact" routerLinkActive="active">Contact</a>
